import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../firebase';
import { useAuth } from '../contexts/AuthContext';
import AuthModal from '../components/AuthModal';
import styles from './CreatePostPage.module.css';

function CreatePostPage() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [text, setText] = useState('');
  const [images, setImages] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      setShowAuthModal(true);
    }
  }, [currentUser]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files || []).slice(0, 2);
    setImageFiles(files);
    const previews = files.map((file) => URL.createObjectURL(file));
    setImages(previews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) {
      setShowAuthModal(true);
      return;
    }

    if (!text.trim() && images.length === 0) {
      return;
    }

    setLoading(true);
    try {
      let imageUrls = [];
      if (imageFiles.length > 0) {
        imageUrls = await Promise.all(
          imageFiles.map(async (file) => {
            const imageRef = ref(storage, `posts/${currentUser.uid}/${Date.now()}_${file.name}`);
            await uploadBytes(imageRef, file);
            return getDownloadURL(imageRef);
          }),
        );
      }

      await addDoc(collection(db, 'posts'), {
        userId: currentUser.uid,
        authorName: currentUser.displayName || currentUser.email?.split('@')[0],
        text: text.trim(),
        images: imageUrls,
        likesCount: 0,
        commentsCount: 0,
        createdAt: serverTimestamp(),
      });

      navigate('/posts');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error creating post:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1>Poser une question</h1>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label htmlFor="text">Votre question (max 300 caractères)</label>
            <textarea
              id="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              maxLength={300}
              rows={6}
              className={styles.textarea}
              placeholder="Posez votre question à la communauté..."
            />
            <div className={styles.charCount}>{text.length}/300</div>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="images">Images (max 2)</label>
            <input
              id="images"
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageChange}
              className={styles.fileInput}
            />
            {images.length > 0 && (
              <div className={styles.imagePreview}>
                {images.map((img, idx) => (
                  <img key={idx} src={img} alt={`Preview ${idx + 1}`} />
                ))}
              </div>
            )}
          </div>

          <button type="submit" className={styles.submitBtn} disabled={loading}>
            {loading ? 'Publication...' : 'Publier la question'}
          </button>
        </form>
      </div>
      {showAuthModal && <AuthModal onClose={() => navigate('/posts')} />}
    </div>
  );
}

export default CreatePostPage;

